import httpService from "./httpService";
import utils from "./utils";

export default {
  findById(id) {
    return httpService.get(`/meetingRoom/${id}`);
  },

  findAll(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get(`/meetingRoom/`, { params: params });
  },

  findAllFreeRooms(deptId, startTime, endTime, includeIds, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { deptId, startTime, endTime, includeIds },
      pageable
    );
    return httpService.get(`/meetingRoom/findAllFreeRooms`, { params: params });
  }
};



// WEBPACK FOOTER //
// ./src/services/hcCfgMeetingRoomService.js